var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 101,
    viewBox: "0 0 272 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 271,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_60642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.284 42.6699H115.288C117.656 42.6699 119.347 43.3435 120.418 44.6907C121.489 46.0379 121.827 47.8342 121.489 50.1356C121.376 51.2021 121.038 52.2125 120.587 53.2229C120.136 54.2333 119.516 55.1315 118.67 55.9735C117.656 56.9839 116.585 57.6574 115.457 57.9381C114.33 58.2188 113.146 58.331 111.906 58.331H108.299L107.171 64.0005H103L107.284 42.6699ZM110.779 46.094L108.975 55.0192C109.088 55.0192 109.2 55.0753 109.313 55.0753C109.426 55.0753 109.595 55.0753 109.708 55.0753C111.624 55.0753 113.203 54.9069 114.499 54.514C115.795 54.1211 116.641 52.6616 117.092 50.1918C117.43 48.1148 117.092 46.936 116.021 46.5992C114.95 46.2624 113.653 46.1502 112.075 46.1502C111.85 46.1502 111.624 46.2063 111.399 46.2063C111.173 46.094 110.948 46.094 110.779 46.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.167 37H130.282L129.098 42.6694H132.818C134.848 42.7256 136.369 43.1185 137.384 43.9044C138.399 44.6902 138.681 46.2058 138.286 48.4511L136.257 58.3867H132.086L134.002 48.9002C134.228 47.8898 134.115 47.2162 133.833 46.7672C133.495 46.3742 132.818 46.1497 131.747 46.1497L128.422 46.0936L125.998 58.3306H121.883L126.167 37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.683 42.6699H150.687C153.054 42.6699 154.745 43.3435 155.816 44.6907C156.887 46.0379 157.225 47.8342 156.887 50.1356C156.774 51.2021 156.436 52.2125 155.985 53.2229C155.534 54.2333 154.914 55.1315 154.069 55.9735C153.054 56.9839 151.983 57.6574 150.856 57.9381C149.729 58.2188 148.545 58.331 147.305 58.331H143.697L142.57 64.0005H138.399L142.683 42.6699ZM146.177 46.094L144.374 55.0192C144.486 55.0192 144.599 55.0753 144.712 55.0753C144.825 55.0753 144.994 55.0753 145.106 55.0753C147.023 55.0753 148.601 54.9069 149.898 54.514C151.194 54.1211 152.04 52.6616 152.491 50.1918C152.829 48.1148 152.491 46.936 151.42 46.5992C150.349 46.2624 149.052 46.1502 147.474 46.1502C147.248 46.1502 147.023 46.2063 146.797 46.2063C146.572 46.094 146.346 46.094 146.177 46.094Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_60642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 27,
    fill: "white",
    transform: "translate(103 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/PHP.9421237df717a268cb4dd9b8b9dd6c1b.svg";
export { ForwardRef as ReactComponent };